import { cn } from "@/utils/theme";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  ScrollArea,
} from "@elaniintc/goes-design-system";
import { useState } from "react";
import type { Variable } from "../../types";
import { DataCenterConditionOperations } from "./condition-operations";
import type { DCOperation } from "../types";

interface ConditionOperationSelectorProps {
  selectedVariable: Variable | null;
  selectedOperation: DCOperation | null;
  onSelectOperation: (operation: DCOperation | null) => void;
  group?:
    | "middle"
    | "up-left"
    | "up-right"
    | "left"
    | "right"
    | "down"
    | "middle-left"
    | "middle-right"
    | "down-right"
    | "down-left";
  disabled?: boolean;
}

export const DCConditionOperationSelector = ({
  selectedVariable,
  selectedOperation,
  onSelectOperation,
  group,
  disabled = false,
}: ConditionOperationSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="quiet"
          group={group}
          className="h-full text-body-loud min-w-0 max-w-1/2"
          disabled={disabled}
        >
          <p className="truncate">{selectedOperation?.label ?? "Acción"}</p>
          <Icon
            type="far"
            name="angle-down"
            className={cn(
              "transition-transform duration-200",
              isOpen ? "rotate-180" : "",
            )}
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="end"
        className="border-neutral h-full rounded-lg w-[280px]"
      >
        <ScrollArea className="max-h-[264px]">
          {selectedVariable?.type &&
            DataCenterConditionOperations[selectedVariable.type].map(
              (operation) => (
                <DropdownMenuItem
                  key={operation.name}
                  className="text-body h-11 text-base"
                  onClick={() => {
                    onSelectOperation(operation);
                    setIsOpen(false);
                  }}
                >
                  {operation.label}
                </DropdownMenuItem>
              ),
            )}
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
